module.exports = __webpack_public_path__ + "img/0005.6a0e8dd7.jpg";